__turbopack_context__.v({
  "actionBtn": "CartItem-module__eOgn2q__actionBtn",
  "actions": "CartItem-module__eOgn2q__actions",
  "bottom": "CartItem-module__eOgn2q__bottom",
  "content": "CartItem-module__eOgn2q__content",
  "image": "CartItem-module__eOgn2q__image",
  "preorder": "CartItem-module__eOgn2q__preorder",
  "price": "CartItem-module__eOgn2q__price",
  "quantity": "CartItem-module__eOgn2q__quantity",
  "removeButton": "CartItem-module__eOgn2q__removeButton",
  "removeIcon": "CartItem-module__eOgn2q__removeIcon",
  "root": "CartItem-module__eOgn2q__root",
  "title": "CartItem-module__eOgn2q__title",
  "top": "CartItem-module__eOgn2q__top",
  "variantName": "CartItem-module__eOgn2q__variantName",
});
